/**
The main dynamic forms component
 * @param {AppState} state - AppState
 */
//Author: Ben Kile
import React, { Component } from "react"
import { AppState } from "src/store"
import { connect } from "react-redux"
import axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import DynamicFormEditor from "../DynamicFormEditor/DynamicFormEditor"
import DynamicFormsHeader from "./DynamicFormsHeader/DynamicFormsHeader"
import DynamicFormsList from "./DynamicFormsList/DynamicFormsList"
import DynamicFormPreview from "../DynamicForm/DynamicFormPreview/DynamicFormPreview"
import CreateDynamicForm from "../CreateDynamicForm/CreateDynamicForm"
import DeleteDynamicForm from "../DeleteDynamicForm/DeleteDynamicForm"
import ReleaseDynamicForm from "../ReleaseDynamicForm/ReleaseDynamicForm"
import TaskDynamicForm from "../TaskDynamicForm/TaskDynamicForm"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import UserReferenceTypes from "src/store/UserReference/types"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import DynamicFormReferenceTypes from "../Types/DynamicFormReferenceTypes"
import snackBar from "src/utilities/snackBar/SnackBar"
import stateMutator from "../Utils/StateMutator"
import DynamicFormsRefreshing from "./DynamicFormsRefreshing/DynamicFormsRefreshing"
import "./DynamicForms.css"
interface Props {
    userId: string | number
    userReference: UserReferenceTypes
    palette: Array<DynamicFormPaletteTypes>
}

interface State {
    forms: Array<DynamicFormTypes> | []
    formsCopy: Array<DynamicFormTypes> | []
    formTypes: Array<{ CustomFormTypeId: number, Type: string }> | []
    formToPreview: DynamicFormTypes | null
    formToEdit: DynamicFormTypes | null
    formToDelete: DynamicFormTypes | null
    formToRelease: DynamicFormTypes | null
    formToTask: DynamicFormTypes | null
    createForm: DynamicFormTypes | null
    busy: boolean
    refresh: boolean
    employees: Array<EmployeeDataTypes> | null
    formReference: DynamicFormReferenceTypes | null
    hints: boolean
}

class DynamicForms3 extends Component<Props, State> {

    palleteHashTable: any
    masterCopy: string = "[]"//!!! temp deep copy fix

    state = {
        forms: [],
        formsCopy: [],
        formTypes: [],
        formToPreview: null,
        formToEdit: null,
        formToDelete: null,
        formToRelease: null,
        formToTask: null,
        createForm: null,
        busy: false,
        refresh: false,
        employees: null,
        formReference: null,
        hints: true
    }

    /**
     * When the component mounts, get the dynamic forms, get the employees, and build the palette hash
     * table and update user settings.
     */
    componentDidMount() {
        this.getDynamicForms()
        this.getEmployees()
        // const settings = msalAuth.UserSettings()
        // if (settings.hasOwnProperty("showFormHints")) {
        //     this.manageState([{ key: "hints", value: settings.showFormHints }])
        // } else {
        //     UserSettings.update({ ...settings, showFormHints: false })
        // }
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    /* A function that takes a string and two arguments. It then calls a function with the name of the
    string and passes the two arguments. */
    callFunction = (functionToCall: string, arg1: any, arg2: any) => {
        //@ts-ignore
        this[functionToCall](arg1, arg2)
    }

    getEmployees = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/getSupervisorUserList/false`, AxiosConfig.configValue())
            .then(res => {
                this.manageState([{ key: "employees", value: res.data.data }])
            }).catch(() => {
                snackBar({ text: "Failed to fetch employee list DynamicForms.tsx", type: "error", timeout: 4000 })
                this.manageState([{ key: "employees", value: [] }])
            })
    }

    getDynamicForms = (openLast?: boolean, noSplash?: boolean) => {
        // console.log("df_DynamicForms getDynamicForms()", openLast, noSplash)
        if (!noSplash) {
            this.manageState([{ key: "busy", value: true }])
        } else {
            this.manageState([{ key: "refresh", value: true }])
        }
        axios.get(process.env.REACT_APP_API_URL + `/api/company/GetDynamicFormsInfo/${this.props.userId}`, AxiosConfig.configValue())
            .then(res => {
                const reference = {
                    DistributionGroups: res.data.DistributionGroups,
                    DistributionPoints: res.data.DistributionPoints,
                    ProfitCenters: res.data.ProfitCenters,
                    States: res.data.States
                }

                this.masterCopy = JSON.stringify(res.data.DynamicForms)//!!! temp deep copy fix

                this.manageState([
                    { key: "forms", value: res.data.DynamicForms },
                    { key: "formsCopy", value: res.data.DynamicForms },
                    { key: "formReference", value: reference },
                    { key: "formTypes", value: res.data.DynamicFormTypes },
                    { key: "busy", value: false },
                    { key: "refresh", value: false },
                    { key: "formToEdit", value: openLast ? res.data.DynamicForms[res.data.DynamicForms.length - 1] : null }
                ])
            })
            .catch(err => {
                //console.log(err)
                this.manageState([
                    { key: "busy", value: false },
                    { key: "refresh", value: false }
                ])
            })
    }

    resetList = () => {//!!! temp deep copy fix
        this.manageState([{ key: "forms", value: JSON.parse(this.masterCopy) }, { key: "formsCopy", value: JSON.parse(this.masterCopy) }])
    }

    render() {

        const props = this.props
        const state = this.state
        // console.log("df_DynamicForms props", props)
        // console.log("df_DynamicForms state", state)
        // console.log("df_DynamicForms REACT_APP_SLOT", process.env.REACT_APP_SLOT)

        return (
            <div className="DynamicForms main-content col-sm">
                <div>
                    {!state.formToEdit && <div className="DynamicFormsNotEditing">
                        <DynamicFormsHeader
                            forms={state.forms}
                            formsCopy={state.formsCopy}
                            manageParentState={this.manageState}
                            callParentFunction={this.callFunction}
                            hints={state.hints}
                        />
                        <DynamicFormsList
                            forms={state.forms}
                            formTypes={state.formTypes}
                            manageParentState={this.manageState}
                            busy={state.busy}
                            hints={state.hints}
                        />
                    </div>}
                    {state.formToEdit && <div className="DynamicFormsEditing">
                        <DynamicFormEditor
                            userId={props.userId}
                            userReference={props.userReference}
                            //@ts-ignore
                            form={state.formToEdit}
                            formTypes={state.formTypes}
                            manageParentState={this.manageState}
                            callParentFunction={this.callFunction}
                            hints={state.hints}
                            palette={this.props.palette}
                        />
                    </div>}
                    {state.createForm && state.formTypes.length > 0 &&
                        <CreateDynamicForm
                            userId={props.userId}
                            formTypes={state.formTypes}
                            manageParentState={this.manageState}
                            callParentFunction={this.callFunction}
                            palette={this.props.palette}
                        />}
                    {state.formToDelete &&
                        <DeleteDynamicForm
                            //@ts-ignore
                            form={state.formToDelete}
                            userId={props.userId}
                            manageParentState={this.manageState}
                            callParentFunction={this.callFunction}
                        />}
                    {state.formToRelease && state.employees &&
                        //@ts-ignore
                        <ReleaseDynamicForm
                            //@ts-ignore
                            form={state.formToRelease}
                            manageParentState={this.manageState}
                            //@ts-ignore
                            employees={state.employees}
                            formReference={this.state.formReference}
                        />}
                    {state.formToTask && state.employees &&
                        //@ts-ignore
                        <TaskDynamicForm
                            //@ts-ignore
                            form={state.formToTask}
                            manageParentState={this.manageState}
                            //@ts-ignore
                            employees={state.employees}
                            //@ts-ignore
                            formReference={this.state.formReference}
                            userId={props.userId}
                            palette={props.palette}
                        />}
                    {state.formToPreview && <DynamicFormPreview
                        form={state.formToPreview}
                        manageParentState={this.manageState}
                        palette={props.palette}
                        enableToolbox={true}
                    />}
                    {state.refresh && <DynamicFormsRefreshing />}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    userReference: state.userReference.userReference,
    palette: state.dynamicFormPalette
})

export default connect(mapStateToProps)(DynamicForms3)